import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconHealthAndSafety.tsx
const OutlinedFilledHealthAndSafety = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M440-360h80v-100h100v-80H520v-100h-80v100H340v80h100v100Zm39.94 305Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Z" })
});
const OutlinedHealthAndSafety = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M440-360h80v-100h100v-80H520v-100h-80v100H340v80h100v100Zm39.94 305Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Zm.06-96q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z" })
});
const RoundedFilledHealthAndSafety = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M440-460v83q0 6 5.5 11.5T457-360h48q7 0 11-5.5t4-11.5v-83h85q7 0 11-5.5t4-11.5v-48q0-7-4-11t-11-4h-85v-85q0-7-4-11t-11-4h-48q-6 0-11.5 4t-5.5 11v85h-83q-6 0-11.5 4t-5.5 11v48q0 6 5.5 11.5T357-460h83Zm40 400q-8 0-15.5-1.5T450-66q-144-47-229.5-177.5T135-523v-189q0-30 16.5-55t44.5-35l251-94q16-6 33-6t33 6l251 94q28 10 45 35t17 55v189q0 149-86 279.5T510-66q-7 3-14.5 4.5T480-60Z" })
});
const RoundedHealthAndSafety = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M440-460v83q0 5.85 5.58 11.42Q451.15-360 457-360h48q7.2 0 11.1-5.58 3.9-5.57 3.9-11.42v-83h85q7.2 0 11.1-5.58 3.9-5.57 3.9-11.42v-48q0-7.2-3.9-11.1-3.9-3.9-11.1-3.9h-85v-85q0-7.2-3.9-11.1-3.9-3.9-11.1-3.9h-48q-5.85 0-11.42 3.9Q440-632.2 440-625v85h-83q-5.85 0-11.42 3.9Q340-532.2 340-525v48q0 5.85 5.58 11.42Q351.15-460 357-460h83Zm40 400q-8.32 0-15.88-1.5Q456.56-63 450-66q-144-47-229.5-177.6Q135-374.19 135-523.11V-712q0-30.26 16.38-55.16Q167.75-792.07 196-802l251-94q16-6 33-6t33 6l251 94q28.25 9.93 45.13 34.84Q826-742.26 826-712v188.89q0 148.92-86 279.51Q654-113 510-66q-6.56 3-14.12 4.5T480-60Zm0-91q110-43 180.5-144T731-523.17V-712l-251-95-251 95v188.83Q229-396 299.5-295 370-194 480-151Zm0-328Z" })
});
const SharpFilledHealthAndSafety = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M440-360h80v-100h100v-80H520v-100h-80v100H340v80h100v100Zm39.94 305Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Z" })
});
const SharpHealthAndSafety = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M440-360h80v-100h100v-80H520v-100h-80v100H340v80h100v100Zm39.94 305Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Zm.06-96q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z" })
});
const componentMap = {
	outlined: OutlinedHealthAndSafety,
	"outlined-fill": OutlinedFilledHealthAndSafety,
	rounded: RoundedHealthAndSafety,
	"rounded-fill": RoundedFilledHealthAndSafety,
	sharp: SharpHealthAndSafety,
	"sharp-fill": SharpFilledHealthAndSafety
};
const IconHealthAndSafety = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t("icon.healthAndSafety"),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconHealthAndSafety };